import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Grid, Stack, TablePagination
} from "@mui/material";
import { styled } from '@mui/material/styles';
import http from "../../utils/http-common";
import { toast } from "react-toastify";
import { Edit as EditIcon, ChangeCircle as ChangeCircleIcon } from '@mui/icons-material';
const StatusButton = styled(Box)(({ status }) => ({
  padding: '2px 8px',
  borderRadius: '20px',
  fontSize: '12px',
  fontWeight: 600,
  backgroundColor: 'transparent',
  border: `1px solid ${getStatusColor(status)}`,
  color: getStatusColor(status),
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '24px',
  minWidth: '90px',
  textTransform: 'capitalize'
}));

// Add this function before your component to get status color
const getStatusColor = (status) => {
  const statusColors = {
    'Open': '#2196F3',        // Blue
    'In Progress': '#FF9800', // Orange
    'Closed': '#4CAF50',   // Green
    
  };
  return statusColors[status] || '#666666'; // Default gray if status not found
};

export default function Assumption () {
    const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);

  // Add pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [assumptionModalOpen, setAssumptionModalOpen] = useState(false);
  const [assumptionData, setAssumptionData] = useState({
    id: "",
    category: "",
    dateLogged: new Date().toISOString().split('T')[0],
    assumption: "",
    confidence: "",
    owner: "",
    rationale: "",
    impact: "",
    status: "Open"
  });

  const [assumptions, setAssumptions] = useState([]);
const planId = localStorage.getItem("plan_id");
useEffect(() => {
    fetchPlanData();
  }, [planId]);
const fetchPlanData = async () => {
    try {
      const response = await http.get(`/master_service/get_project/plan/summary/${planId}`);
      if (response.status === 200) {
        const data = response.data.assumptions.map(item => ({
      id: item.ass_id,
      category: item.category,
      dateLogged: item.date_logged,
      assumption: item.assumption,
      confidence: item.confidence,
      owner: item.owner,
      rationale: item.rationale,
      impact: item.impact,
      status: item.status
        }));
        setAssumptions(data);
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };

  const [filters, setFilters] = useState({
  issues: '',
  assumptions: '',
  risks: '',
  dependencies: '',
  constraints: ''
});
const filterAssumptions = () => {
  return assumptions.filter(assumption =>
    Object.values(assumption).some(value =>
      value ? value.toString().toLowerCase().includes(filters.assumptions.toLowerCase()) : false
    )
  );
};

const [expandedSections, setExpandedSections] = useState({});
const toggleSection = (sectionId) => {
  setExpandedSections(prev => ({
    ...prev,
    [sectionId]: !prev[sectionId]
  }));
};
const handleInputChange1 = (field, value) => {
  setAssumptionData(prev => ({ ...prev, [field]: value }));
};
const handleFilterChange = (table, value) => {
  setFilters(prev => ({
    ...prev,
    [table]: value
  }));
};

  const handleEdit = (assumption) => {
    setAssumptionData({
      id: assumption.id,
      category: assumption.category,
      dateLogged: assumption.dateLogged,
      assumption: assumption.assumption,
      confidence: assumption.confidence,
      owner: assumption.owner,
      rationale: assumption.rationale,
      impact: assumption.impact,
      status: assumption.status
    });
    setAssumptionModalOpen(true);
  };
  const handleStatusUpdate = async (assumption) => {

    const nextStatus = getNextStatus(assumption.status);
    try {
      const payload = {
        ass_id: assumption.id,
        "category": assumption.category,
        "date_logged": assumption.dateLogged,
        "assumption": assumption.assumption,
        "confidence": assumption.confidence,
        "owner": assumption.owner,
        "rationale": assumption.rationale,
        "impact": assumption.impact,
        "plan_id": planId,
        status: nextStatus,
      };
      const response = await http.post('/master_service/create_update/assumption', payload);
      if (response.status === 200 || response.status === 201) {
        toast.success("Status updated successfully");
        fetchPlanData();
      }
    } catch (error) {
      toast.error("Failed to update status");
    }
  };

  // Helper function to determine next status
  const getNextStatus = (currentStatus) => {
    const statusFlow = {
      'Open': 'In Progress',
      'In Progress': 'Closed',
      'Closed': 'Open',
    };
    return statusFlow[currentStatus] || 'Open';
  };

  const handleSave = async (data, closeModal, resetData) => {
    try {
      const payload = {
        ass_id: data.id,
        plan_id: planId,
        "category": data.category,
        "date_logged": data.dateLogged,
        "assumption": data.assumption,
        "confidence": data.confidence,
        "owner": data.owner,
        "rationale": data.rationale,
        "impact": data.impact,
        "status": data.status
      }
      const response = await http.post('/master_service/create_update/assumption', payload);
      if (response.status === 201 || response.status === 200) {
        toast.success("Data saved successfully");
        closeModal(false);
        resetData();
        fetchPlanData();
      }
    } catch (error) {
      toast.error("Failed to save data1");
    }
  };

  return (
    <Container maxWidth={false} sx={{ width: "100%", p: 1 }}>
      {/* Assumption Log Table */}
   <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', bgcolor: '#F7F8F8', p: 0.5, mb: 0.2 }}>
   <Box sx={{display:"flex", justifyContent:"flex-start", alignItems:"center"}}>
   <Typography style={{fontWeight: "600"}}>Assumption</Typography>
    <Typography sx={{ ml: 1, fontSize: '12px' }}>({assumptions.length} Assumptions)</Typography>
  </Box>
<Box sx={{display:"flex", justifyContent:"flex-end", alignItems:"center"}}>
    <TextField
      size="small"
      placeholder="Search here..."
      value={filters.assumptions}
      onChange={(e) => handleFilterChange('assumptions', e.target.value)}
      sx={{ ml: 2, mr:1, minWidth: '200px' }}
    />
        <Button
            onClick={() => {
              setAssumptionModalOpen(true)
              setAssumptionData({});
            }}
            sx={{ 
            minWidth: '24px',
            width: '26px',
            height: '26px',
            p: 0,
            mr: '4px',
            color: '#FFF',
            border: 'none',
            backgroundColor: '#FF2800',
            '&:hover': {
                backgroundColor: '#FF2800',
                border: 'none'
            }
        }}
          >
            +
          </Button>
  
</Box>
</Box>
  <TableContainer component={Paper} sx={{ mb: 3 }}>
        <Table size="small">
          <TableHead sx={{ backgroundColor: "#e0eaff" }}>
            <TableRow  sx={{'& .MuiTableCell-head': { py: 0.1, fontSize: '12px', fontWeight: 500 } }}>
              <TableCell>ID</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Date Logged</TableCell>
              <TableCell>Assumption</TableCell>
              <TableCell>Confidence</TableCell>
              <TableCell>Owner</TableCell>
              <TableCell>Rationale</TableCell>
              <TableCell>Impact</TableCell>
              <TableCell>Status</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filterAssumptions().slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((assumption, index) => (
              <TableRow key={index} sx={{ '& .MuiTableCell-body': { py: 0.2 } }}>
                <TableCell>{assumption.id}</TableCell>
                <TableCell>{assumption.category}</TableCell>
                <TableCell>{assumption.dateLogged}</TableCell>
                <TableCell>{assumption.assumption}</TableCell>
                <TableCell>{assumption.confidence}</TableCell>
                <TableCell>{assumption.owner}</TableCell>
                <TableCell>{assumption.rationale}</TableCell>
                <TableCell>{assumption.impact}</TableCell>
                <TableCell><StatusButton status={assumption.status}>{assumption.status}</StatusButton></TableCell>
                <TableCell>
                  <Stack direction="row" spacing={1}>
                    <IconButton
                      size="small"
                      onClick={() => handleEdit(assumption)}
                      sx={{ p: 0.5 }}
                    >
                      <EditIcon sx={{ height: "18px", width: "18px", color: "#666" }} />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleStatusUpdate(assumption)}
                      sx={{ p: 0.5 }}
                    >
                      <ChangeCircleIcon sx={{ height: "18px", width: "18px", color: getStatusColor(assumption.status) }} />
                    </IconButton>
                  </Stack>
                    </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
          {filterAssumptions().length > 10 && (
          <TablePagination
            rowsPerPageOptions={[10]}
            component="div"
            count={filterAssumptions().length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            sx={{
              '.MuiTablePagination-toolbar': {
                minHeight: '40px',
              },
              '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                fontSize: '12px',
              }
            }}
          />
        )}
      </TableContainer>
      <Modal
        open={assumptionModalOpen}
        onClose={() => setAssumptionModalOpen(false)}
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-end"
        }}
      >
        <Box
          sx={{
            width: "350px",
            height: "100%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 1,
            overflowY: "auto",
    '& .MuiInputBase-input': { // Add this style to reduce input font size
      fontSize: '0.875rem'
    },
    '& .MuiInputLabel-root': { // Add this style to reduce label font size
      fontSize: '0.875rem'
    },
    '& .MuiMenuItem-root': { // Add this style to reduce dropdown item font size
      fontSize: '0.875rem'
    }
          }}
        >
          <Typography mb={1} style={{font: 'bold', fontWeight: '600'}}>Add Assumption</Typography>
          <FormControl fullWidth sx={{ mb: 1.5 }} size="small">
  <InputLabel id="category-label">Category</InputLabel>
  <Select
    labelId="category-label"
    value={assumptionData.category}
    label="Category"
    onChange={(e) =>
      handleInputChange1("category", e.target.value)
    }
  >
    <MenuItem value="Strategic">Strategic</MenuItem>
    <MenuItem value="Operational">Operational</MenuItem>
    <MenuItem value="Financial">Financial</MenuItem>
  </Select>
</FormControl>
          <TextField
            fullWidth
            type="date"
            label="Date Logged"
            value={assumptionData.dateLogged}
            onChange={(e) => handleInputChange1("dateLogged", e.target.value)}
            sx={{ mb: 1.5 }}
            InputLabelProps={{
    shrink: true, // keeps label visible above the date field
  }}
            size="small"
                inputProps={{
              max: new Date().toISOString().split("T")[0]  // ✅ Only allow today & future
            }}        
          />
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Assumption"
            value={assumptionData.assumption}
            onChange={(e) => handleInputChange1("assumption", e.target.value)}
            sx={{ mb: 1.5 }}
            size="small"
            inputProps={{ maxLength: 200 }}
          />

          <FormControl fullWidth sx={{ mb: 1.5 }} size="small">
            <InputLabel id="confidence-label">Confidence</InputLabel>
            <Select
              labelId="confidence-label"
              value={assumptionData.confidence}
              label="Confidence"
              onChange={(e) => handleInputChange1("confidence", e.target.value)}
            >
              <MenuItem value="High">High</MenuItem>
              <MenuItem value="Medium">Medium</MenuItem>
              <MenuItem value="Low">Low</MenuItem>
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Owner"
            value={assumptionData.owner}
            onChange={(e) => {
            const newValue = e.target.value;
              handleInputChange1("owner", newValue);
            }
            }
              sx={{ mb: 1.5 }}
            size="small"
          />

          <TextField
            fullWidth
            multiline
            rows={2}
            label="Rationale"
            value={assumptionData.rationale}
            onChange={(e) => handleInputChange1("rationale", e.target.value)}
            sx={{ mb: 1.5 }}
            size="small"
            inputProps={{ maxLength: 100 }}
          />

          <TextField
            fullWidth
            multiline
            rows={2}
            label="Impact"
            value={assumptionData.impact}
            onChange={(e) => handleInputChange1("impact", e.target.value)}
            sx={{ mb: 1.5 }}
            size="small"
            inputProps={{ maxLength: 100 }}
          />
           <FormControl fullWidth sx={{ mb: 0.5 }}>
            <InputLabel>Status</InputLabel>
            <Select
              value={assumptionData.status}
              label="Status"
              onChange={(e) => handleInputChange1("status", e.target.value)}
              size="small"
            >
              <MenuItem value="Open">Open</MenuItem>
              <MenuItem value="In Progress">In Progress</MenuItem>
              <MenuItem value="Closed">Closed</MenuItem>
            </Select>
          </FormControl>
          <Button
            fullWidth
            onClick={() => handleSave(assumptionData, setAssumptionModalOpen, () => setAssumptionData({
              id: "",
              category: "",
              dateLogged: new Date().toISOString().split('T')[0],
              assumption: "",
              confidence: "",
              owner: "",
              rationale: "",
              impact: "",
              status: "Open"
            }))}
            sx={{
              textTransform: "none",
              bgcolor: '#FF2800',
              color: 'white',
              mb: 0.5,
              "&:hover": { bgcolor: "#FF2800" }
            }}
          >
            Save
          </Button>

          <Button
            fullWidth
            onClick={() => setAssumptionModalOpen(false)}
            sx={{ textTransform: "none", bgcolor: 'white', color: 'black' }}
          >
            Cancel
          </Button>
        </Box>
      </Modal>
      </Container> 
  )
}